export const buildInitialFeedState = (overrides) => ({
  entity: null,
  parentEntityId: null,
  entityId: null,
  autoPlayVideos: {},
  isAutoplayEnabled: true,
  ...overrides
});

export default { buildInitialFeedState };
